import {
  RawEventData,
  RawPlayEventData,
  RawPossessionEventData,
  RawSessionEventData,
  RawTimingEventData
} from '@frontend/core'
import { EMPTY_RAW_SESSION_EVENT_DATA } from '@frontend/core/lib/domains/events'
import { EMPTY_FORMATTED_SESSION } from '@frontend/core/lib/domains/sessions'
import { FormattedSession } from '@frontend/core/lib/domains/sessions/types'
import { EventTypeConfig } from '@frontend/core/lib/domains/sports/config'
import { HotKeyConfigMap } from '@frontend/react/utils/hotkeys'
import { SortingState } from '@tanstack/react-table'
import { createContext } from 'react'
import { useEventsData } from '../events'

export const SessionContext = createContext<{
  formattedSession: FormattedSession
  sessionEvent: RawSessionEventData
  hotKeyConfig: HotKeyConfigMap | null
}>({
  formattedSession: EMPTY_FORMATTED_SESSION,
  sessionEvent: EMPTY_RAW_SESSION_EVENT_DATA,
  hotKeyConfig: null
})

export const SessionEventContext = createContext<{
  // Time Events //
  timeEvents: ReturnType<typeof useEventsData> | null
  isCurrentPeriodActive: boolean
  activeStoppage: RawEventData | null
  nextPeriodEventType: EventTypeConfig | null
  currentPeriodEventType: EventTypeConfig | null
  isFullTime: boolean
  periodCount: number
  standardOvertimeCount: number | null
  currentPeriod: RawTimingEventData | null
  latestPlay: RawPlayEventData | null
  currentPlay: RawPlayEventData | null

  // Drill Events //
  drillEvents: ReturnType<typeof useEventsData> | null

  // Sport Events //
  sportEvents: ReturnType<typeof useEventsData> | null

  // Possession Events //
  teamPossessionEvents: ReturnType<typeof useEventsData> | null
  currentTeamPossession: RawPossessionEventData | null

  // Event Validation Table Sorting //
  tableSorting: SortingState
  setTableSorting: (sorting: SortingState) => void
}>({
  timeEvents: null,
  isCurrentPeriodActive: false,
  activeStoppage: null,
  nextPeriodEventType: null,
  currentPeriodEventType: null,
  isFullTime: false,
  periodCount: 0,
  standardOvertimeCount: null,
  currentPeriod: null,
  latestPlay: null,
  currentPlay: null,
  drillEvents: null,
  sportEvents: null,
  teamPossessionEvents: null,
  currentTeamPossession: null,
  tableSorting: [],
  setTableSorting: () => undefined
})
